"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export function RouteChangeListener() {
  const pathname = usePathname();
  const [previousPath, setPreviousPath] = useState("");

  // list of paths were we expect the page to scroll to the top
  const mainPaths = ["/services", "/shop", "/services/all", "/shop/all"];

  /**
   * Check if we need to scroll the page to the top. This is true when previous and current paths are different and both are in the mainPaths list.
   * otherwise we assume the page should not scroll to the top.
   * @returns {boolean}
   */
  const checkPreviousPath = () => {
    const foundPathName = mainPaths.includes(pathname);
    const foundPreviousPathName = mainPaths.includes(previousPath);
    return (!previousPath && foundPathName) || (foundPreviousPathName && foundPathName && previousPath !== pathname);
  };

  useEffect(() => {
    // keep history of the previous path
    if (previousPath !== pathname) {
      setPreviousPath(pathname);
    }

    const mainElm = document.querySelector("main");
    const shouldScrollToTop = checkPreviousPath();

    if (mainElm && shouldScrollToTop){
      mainElm.scrollTop = 0;
    }
  }, [pathname, previousPath]);

  return <></>;
}
